import getHtmlParam from '../../utilities/htmlParam';
import {initSingleReco} from '../global/splide';
import {domReady} from '../../utilities/domready';

export class Reco {

  private param: Map<any, any>;

  showRecommendation() {
    const recommendation = document.getElementById('recommendation');
      const recov3 = document.querySelector('.pda.reco-v3');
      let perPage:number = 5;
      let recoVer:string = 'v2';
      if(recov3) {
          perPage = 7;
          recoVer = 'v3';
      }
    window.fetch(this.param.get('urlPrefix') + '/mapping/new/reco?key=' + this.param.get('productId') + '&reco=clicks&filter=' + this.param.get('accessoryIds') + '&maxRecos=10&fallbacks=item-based&recos=' + recoVer)
        .then((res) => {
          if (!res.ok) {
            throw Error(res.statusText);
          }
          return res.text()
        })
        .then(html => {
          recommendation && (recommendation.innerHTML = html);
          initSingleReco('#recommendation .splide', perPage);
        }).catch(err => {
          recommendation.parentNode.removeChild(recommendation);
          console.log(err);
        });
  }

  showABTastyClickRecommendation() {
    const recommendation = document.getElementById('abTastyClickRecommendation');

    window.fetch(this.param.get('urlPrefix') + '/mapping/abtasty/clicks?requestedMaxRecos=14&minRecos=0&msg=SSH.MAPPING.HEADLINE_RECOMMENDED&slidesPerView=3&cssClass=product-swiper-container&showCheckbox=false&isModal=false&currentArticleId=' + this.param.get('selectedItem'))
    .then((res) => {
      if (!res.ok) {
        throw Error(res.statusText);
      }
      return res.text()
    })
    .then(html => {
      recommendation && (recommendation.innerHTML = html);
      initSingleReco('#abTastyClickRecommendation .splide', 7);
    }).catch(err => {
      recommendation.parentNode.removeChild(recommendation);
      console.log(err);
    });
  }

  showCategoryReco() {
    const jsRecoTopsellerNotavailable = document.getElementById('js-reco-topseller-notavailable');
    const jsRecoTopseller = document.getElementById('js-reco-topseller');
    const recov3 = document.querySelector('.pda.reco-v3');
    const showUpseller = this.param.get('topsellerTrial') === 'upseller';
    let perPage:number = 3;
    let recoVer:string = 'v2';
    if(recov3) {
        perPage = 7;
        recoVer = 'v3';
    }
    const recoPath = showUpseller ? 'upselling' : 'topseller';
    window.fetch(this.param.get('urlPrefix') + '/mapping/' + recoPath + '/reco?tenant=' + this.param.get('productContextTenant') + '&profile=' + this.param.get('productContextProfile') + '&locale=' + this.param.get('productContextLocale') + '&category=' + this.param.get('categoryId') + '&interval=7&base=REVENUE&productId=' + this.param.get('productId') + '&layoutVersion=default&msg=ssh.product.reco.categoryTopseller&recos=' + recoVer
        + '&price=' + encodeURIComponent(this.param.get('price')))
        .then((res) => {
          if (!res.ok) {
            throw Error(res.statusText);
          }
          return res.text()
        })
        .then(html => {
          if(this.param.get('tmpNotAvailable') === 'true') {
            jsRecoTopsellerNotavailable && (jsRecoTopsellerNotavailable.innerHTML = html);
            initSingleReco('#js-reco-topseller-notavailable .splide', 7);
          } else {
            html = html.replace('padding-horizontal-normal', 'padding-horizontal-small');
            jsRecoTopseller && (jsRecoTopseller.innerHTML = html);
            initSingleReco('#js-reco-topseller .splide', perPage);
          }
        }).catch(err => {
          if(this.param.get('tmpNotAvailable') === 'true') {
            jsRecoTopsellerNotavailable.parentNode.removeChild(jsRecoTopsellerNotavailable);
          } else {
            jsRecoTopseller.parentNode.removeChild(jsRecoTopseller);
          }
          console.log(err);
        });
  }

  showLastseen() {
    const lastSeen = document.getElementById('lastseen');
    window.fetch(this.param.get('urlPrefix') + '/mapping/lastseen?productId=' + this.param.get('productId') + '&recos=v2')
        .then((res) => {
          if (!res.ok) {
            throw Error(res.statusText);
          }
          return res.text()
        })
        .then(html => {
          lastSeen && (lastSeen.innerHTML = html);
          initSingleReco('#lastseen .splide', 10);
        }).catch(err => {
          lastSeen.parentNode.removeChild(lastSeen);
          console.log(err);
        });
  }

  getLastseen(perPage: number = 8) {
    const lastSeen = document.getElementById('lastseen');
    if (!lastSeen) return;
    const data = getHtmlParam('.js-param .param');
    window.fetch(data.get('urlPrefix') + '/mapping/lastseen?recos=v2&productId=')
        .then((res) => {
          if (!res.ok) {
            throw Error(res.statusText);
          }
          return res.text()
        })
        .then(html => {
          lastSeen && (lastSeen.innerHTML = html);
          initSingleReco('#lastseen .splide', perPage);
        }).catch(err => {
          lastSeen.parentNode.removeChild(lastSeen);
          console.log(err);
        });
  }

  init() {
    domReady(() => {
      this.param = getHtmlParam('.js-param .param');

      this.showRecommendation();
      this.showCategoryReco();
      this.showLastseen();
      this.showABTastyClickRecommendation();

      const accessoriesSwiper = document.querySelector('.accessories-swiper-container');
      accessoriesSwiper && initSingleReco('.accessories-swiper-container', 5);

      //1. Crossseller 2. Accessories 3. Ordered Together
      const recov3 = document.querySelector('.pda.reco-v3');
      if(recov3) {
        initSingleReco('.upselling-swiper-container', 7);
      } else {
        if(this.param.get('tmpNotAvailable') === 'true') {
            initSingleReco('.upselling-swiper-container', 5);
        } else {
            initSingleReco('.upselling-swiper-container', 3);
        }
      }

    });
  }
}